import { Group } from "@mantine/core";

import { Editor, useEditorState } from "@tiptap/react";

import { TextWrapper } from "@/components/TextWrapper";

import {
  DOT_PHRASE_FIELD_COUNT_HINT,
  DOT_PHRASE_FIELD_NAVIGATION_HINT,
} from "../../constants/dot-phrases";
import { readDotPhraseFields } from "../../tiptap/dot-phrase-fields-state";

import classes from "./DotPhraseFieldHint.module.css";

export interface DotPhraseFieldHintProps {
  editor: Editor | null;
}

export default function DotPhraseFieldHint({ editor }: DotPhraseFieldHintProps) {
  const fieldCount = useEditorState({
    editor,
    selector: ({ editor }) => (editor ? readDotPhraseFields(editor.state).length : 0),
  });

  if (!fieldCount) return null;

  return (
    <Group gap="xs" wrap="nowrap" className={classes.hint} data-testid="dot-phrase-field-hint">
      <TextWrapper fw={600} size="sm" c="dark.9">
        {DOT_PHRASE_FIELD_COUNT_HINT(fieldCount)}
      </TextWrapper>

      <TextWrapper size="sm" c="gray.7">
        {DOT_PHRASE_FIELD_NAVIGATION_HINT}
      </TextWrapper>
    </Group>
  );
}
